const initGoogleEcommerce = () => {
  let dataLayer = window.dataLayer || [];
  const cart = document.querySelector('input[type=hidden][name=cart]');

  if(cart) {
    let dataObject = {
      'event': 'checkout_view',
      'category': 'page',
      'label': 'label_checkout_view'
    };

    if (typeof dataLayer != 'undefined') {
      dataLayer.push(dataObject);
      dataLayer.push({
        'event': 'EEcheckout',
        'ecommerce': {
          'checkout': {
            'actionField': {'step': 1},
            'products': [{
              'name': cart.dataset.productName,
              'id': cart.dataset.productId,
              'price': cart.dataset.amount,
              'brand': cart.dataset.productBrand,
              'category': 'Experience',
              'quantity': 1
            }]
          }
        }
      });
    }
  }

  if(typeof dataLayer != 'undefined'){
    //if we find this, it means we are on the experience page
    //so we trigger the view_item event
    const bookingForm = document.getElementById('booking-form');
    if(bookingForm){
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: "view_item",
        ecommerce: {
          items: [{
            item_id: bookingForm.dataset.experienceId,
            item_name: bookingForm.dataset.experienceName,
            currency: bookingForm.dataset.hostCurrency,
            item_brand: bookingForm.dataset.hostName,
            item_category: bookingForm.dataset.categoryOne,
            item_category2: bookingForm.dataset.categoryTwo,
            item_category3: bookingForm.dataset.categoryThree,
            item_category4: bookingForm.dataset.categoryFour,
            quantity: 1
          }]
        }
      });
    }

    const giftFormCheckout = document.getElementById('gift-choose-form');
    const giftCheckoutWrapper = document.getElementById('gift-card-wrapper');
    if(giftFormCheckout && giftCheckoutWrapper){
      giftFormCheckout.addEventListener('submit', () => {
        try{
          let price = 0;
          const gcType = document.querySelector("input[name='type']:checked");
          const priceRadio = document.querySelector("input[name='radioAmount']:checked");
          const customPrice = document.querySelector("input[name='amount']");
          const expBasedAmount = document.getElementById('experience-based-amount');
          if(expBasedAmount && expBasedAmount.checked){
            const expBasedInputAdults = document.getElementById('experience-based-amount-input-adults');
            const expBasedInputChildren = document.getElementById('experience-based-amount-input-children');
            price = expBasedInputAdults.value * expBasedInputAdults.dataset.price;
            if(expBasedInputChildren && expBasedInputChildren.value != 0){
              price += expBasedInputChildren.value * expBasedInputChildren.dataset.price;
            }
          }
          else{
            price = priceRadio ? priceRadio.value : customPrice.value;
          }

          let options = {
            item_id: giftCheckoutWrapper.dataset.experienceId,
            item_name: gcType?.value ?? 'print',
            currency: 'EUR',
            item_brand: giftCheckoutWrapper.dataset.hostName,
            item_category: giftCheckoutWrapper.dataset.categoryOne,
            item_category2: giftCheckoutWrapper.dataset.categoryTwo,
            item_category3: giftCheckoutWrapper.dataset.categoryThree,
            item_category4: giftCheckoutWrapper.dataset.categoryFour,
            quantity: 1
          }

          dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              currency: options.currency,
              value: price,
              items: [options]
            }
          });
        } catch (err){
          console.error(err);
        }
      });
    }
  }
};

// trigger add to cart event when user add to cart on experience page
const ecommerceExperienceAddToCart = (value, currency) => {
  let dataLayer = window.dataLayer || [];

  try {
    const bookingForm = document.getElementById('booking-form');
    if(bookingForm){
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: currency,
          value: value,
          items: [{
            item_id: bookingForm.dataset.experienceId,
            item_name: bookingForm.dataset.experienceName,
            currency: bookingForm.dataset.hostCurrency,
            item_brand: bookingForm.dataset.hostName,
            item_category: bookingForm.dataset.categoryOne,
            item_category2: bookingForm.dataset.categoryTwo,
            item_category3: bookingForm.dataset.categoryThree,
            item_category4: bookingForm.dataset.categoryFour,
            quantity: 1
          }]
        }
      });
    }
  } catch (err) {
    console.error('Error in add_to_cart:', err);
  }
}

export { initGoogleEcommerce, ecommerceExperienceAddToCart };
